// src/plugins/version-plugin.js
const VersionPlugin = {
  install(Vue) {
    // สร้าง reactive version object
    const versionData = Vue.observable({
      version: '1.0.0',
      buildDate: null,
      buildNumber: null,
      loading: false,
      error: null
    });

    // เพิ่ม $appVersion เป็น global property
    Vue.prototype.$appVersion = versionData;

    // เพิ่ม method สำหรับโหลด version
    Vue.prototype.$loadAppVersion = async function() {
      versionData.loading = true;
      versionData.error = null;

      try {
        const response = await fetch('./version.json?t=' + Date.now());
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error('Invalid content type');
        }

        const data = await response.json();
        versionData.version = data.version || '1.0.0';
        versionData.buildDate = data.buildDate;
        versionData.buildNumber = data.buildNumber;
        
        console.log('✅ App version loaded:', versionData.version);
        return data;
      } catch (error) {
        console.warn('⚠️ Could not load version:', error.message);
        versionData.error = error.message;
        // ใช้ค่า default
        versionData.version = '1.0.0';
        versionData.buildDate = new Date().toISOString();
        versionData.buildNumber = Date.now();
      } finally {
        versionData.loading = false;
      }
    };
  }
};

export default VersionPlugin;